const getters = {
  ISUSERLOGGED (state) {
    return state.isUserLogged
  },

  USERID (state) {
    return state.user.id
  },

  USERNAME (state) {
    return state.user.name
  },

  USEREMAIL (state) {
    return state.user.email
  },

  USERTOKEN (state) {
    return state.user.token
  },

  PROFILE (state) {
    return state.profile
  },

  CURRENTPROFILE (state) {
    return state.currentProfile
  },

  isAdmin (state) {
    return state.profile === 'admin'
  },

  REDIRECTO (state) {
    return state.redirectTo
  },
}

export default getters
